import PlaylistAddCheckRoundedIcon from "@mui/icons-material/PlaylistAddCheckRounded";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";

// Soft/hard run choices shown with ModeCards. The values are the API modes.
const missingOnly = (description) => ({
  value: "soft",
  title: "Missing only",
  description,
  icon: PlaylistAddCheckRoundedIcon,
  tone: "info",
});

const overwriteAll = (description) => ({
  value: "hard",
  title: "Overwrite all",
  description,
  icon: RestartAltRoundedIcon,
  tone: "warning",
});

export const RETRANSLATE_MODE_OPTIONS = [
  missingOnly("Keeps existing translations"),
  overwriteAll("Replaces every translation"),
];

export const CREATE_TAKES_MODE_OPTIONS = [
  missingOnly("Keeps existing takes"),
  overwriteAll("Replaces every take"),
];

// Stem separation services an admin can run. The values are the API providers.
export const STEM_SEPARATION_OPTIONS = [
  { value: "demucs", label: "Demucs (in-house)" },
  { value: "audioshake", label: "AudioShake (3rd party)" },
];

// AudioShake separates dialogue from music and effects, so songs stay out of
// the dialogue track; project creation already defaults to it.
export const DEFAULT_STEM_SEPARATION_PROVIDER = "audioshake";
